import styled from 'styled-components';

export const Contact = styled.section`
  position: relative;
  overflow: hidden;
  background-color: ${({ theme: { colors } }) => colors.pink};
  min-height: 470px;

  .container {
    padding-top: 167px;
    padding-bottom: 167px;

    @media only screen and (max-width: 767px) {
      padding-top: 30px;
    }
  }

  .circle-1,
  .circle-2,
  .circle-3 {
    position: absolute;
    left: 300px;
    top: 50%;
    margin-top: -50%;
    width: 100vw;
    height: 100vw;
    border-radius: 100%;
    opacity: 0;
    background-color: rgba(255, 255, 255, 0.2);

    @media only screen and (max-width: 767px) {
      top: unset;
      bottom: -200px;
      left: 12%;
      margin-top: 0;
      margin-left: -50%;
      width: 100vh;
      height: 100vh;
    }
  }

  .circle-1 {
    animation: circle-one-animation 2.4s ease-out infinite;
  }

  .circle-2 {
    animation: circle-two-animation 2.4s ease-out infinite;
  }

  .circle-3 {
    animation: circle-three-animation 2.4s ease-out infinite;
  }

  @media only screen and (max-width: 767px) {
    padding-top: 50px;
  }

  .globe-image {
    background-color: ${({ theme: { colors } }) => colors.pink};
    min-height: 478px;
  }

  @keyframes circle-one-animation {
    0% {
      opacity: 0;
      -webkit-transform: scale(0.25);
      transform: scale(0.25);
    }

    20% {
      opacity: 1;
    }

    to {
      opacity: 0;
      -webkit-transform: scale(0.4);
      transform: scale(0.4);
    }
  }

  @keyframes circle-two-animation {
    0% {
      opacity: 0;
      -webkit-transform: scale(0.35);
      transform: scale(0.35);
    }

    20% {
      opacity: 1;
    }

    to {
      opacity: 0;
      -webkit-transform: scale(0.65);
      transform: scale(0.65);
    }
  }

  @keyframes circle-three-animation {
    0% {
      opacity: 0;
      -webkit-transform: scale(0.45);
      transform: scale(0.45);
    }

    20% {
      opacity: 1;
    }

    to {
      opacity: 0;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
`;
